import React, { useEffect, useState } from 'react'
import { PendingListData } from './PendingListData';
import BreadCrumb from '../../../../../../Components/Common/BreadCrumb';
import { Button, Card, CardBody, Col, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Input, InputGroup, Row } from 'reactstrap';
import { Link } from 'react-router-dom';
import CustomDataTable from '../../../../../../Components/CustomTable/CustomTable';
import { formatDateTime } from '../../../../../../Components/Common/FormatDate';

const PendingListPage = () => {
   const [searchTerm, setSearchTerm] = useState('');
  const [loading,setLoading] = useState(false)
   const [dataList, setDataList] = useState([]);
   const [data,setData] =  useState()
  useEffect(()=>{
      const fetchData = async () => {
      try {
        const result = await DatabaseMgmt.getAll();
        setDataList(result);
      } catch (error) {
        console.error("Failed to load data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  },[])
  
  console.log(dataList)
  const [filterText, setFilterText] = useState('');
  const [addModal, setAddModal] = useState(false);
 

  const handleFilterChange = (e) => {
    setFilterText(e.target.value);
  };

  const filteredData = PendingListData.filter(doc => 
        doc.complainantName.toLowerCase().includes(searchTerm.toLowerCase())
);
const customStyles = {
  headCells: {
    style: {
      fontSize: "0.92rem",
      fontWeight: 610,
      width: "max-content",  
    },
  },
  rows: {
    style: {
      fontSize: "0.9rem",
    },
  },
};


  const columns = [
    {
      name: 'S No',
      cell:(row,index)=>index+1,
      width:"85px",
      sortable: true
    },
    {
      name: 'Customer Name',
      width:"165px",
      selector: (row) =>  <span title={row.complainantName}>
        <Link to={`/pendingList/${row.id}`}>

          {row.complainantName}
        </Link>
        </span>,
      sortable: true
    },
    {
      name: 'Respondent Name',
      width:"205px",
      selector: (row) => row.respondentName,
      sortable: true
    },
    {
      name: 'Dispute Type',
      selector: (row) => row.disputeType,
      width:"205px",
      sortable: true
    },
    {
      name: 'Filed Date',
      selector: (row) => row.filedDate,
      width:"145px",
      sortable: true
    },
      {
      name: 'Last Updated',
      selector: (row) => row.lastUpdated,
      width:"145px",
      sortable: true
    },
    {
      name: 'Status',
      selector: (row) => row.status,
      width:"175px",
      sortable: true
    },
      {
  name: 'Priority',
  selector: (row) => row.priority,
  width: "105px",
  sortable: true,
  center:true,
  cell: (row) => (
    <div
      className={`btn btn-sm px-2 text-capitalize ${
        row.priority.toLowerCase() === "high"
          ? "btn-danger"
          : row.priority.toLowerCase() === "medium"
          ? "btn-warning"
          : "btn-success"
      }`}
      onClick={() => console.log("Button clicked for", row)}
    >
      <p className="p-0 m-0">{row.priority}</p>
    </div>
  ),
},

    
  ];

  return (
    <div className="page-content">
      <div className="container-fluid">
        <BreadCrumb title="Pending List" pageTitle="Memo" />
      </div>
      <Row>
        <Col md={8} xs={10} className="mb-2">
          <InputGroup>
            <Input
              placeholder="Search by Customer Name"
             alue={searchTerm} onChange={(e) => setSearchTerm(e.target.value)}
            />
          </InputGroup>
        </Col>
        <Col
          md={4}
          xs={2}
          className="d-flex d-lg-none justify-content-end align-items-end mb-2"
        >
        
        </Col>
      </Row>
      <Card className="d-none d-lg-block">
        <CardBody>
          <CustomDataTable
            responsive
            striped
            pagination
            fixedHeader
            persistTableHead
            progressPending={loading}
            customStyles={customStyles}
            progressComponent={
              <div className="my-3">
                {/* <Triangle
                  visible={true}
                  height="80"
                  width="80"
                  color="#5B71B9"
                  ariaLabel="triangle-loading"
                /> */}
                <h5 className="mt-1">Loading...</h5>
              </div>
            }
            columns={columns}
            data={filteredData || []}
          />
        </CardBody>
      </Card>
      {loading ? (
        <div className="my-5 d-flex justify-content-center">
          <h5 className="mt-1">Loading...</h5>
        </div>
      ) : (
        <>
          {filteredData?.map((item, index) => (
            <Card
              key={item.id || index}
              className="mb-3 shadow-sm d-block d-lg-none mt-2"
            >
              <CardBody>
                <Row>
                 <Col xs={10}>

  <h6 className="mb-2">
    <strong>Customer Name:</strong>{" "}
    <Link to={`/pendingList/${item.id}`} title={item.complainantName}>
      {item.complainantName}
    </Link>
  </h6>
  <h6 className="mb-2">
    <strong>Respondent Name:</strong> {item.respondentName}
  </h6>
  <h6 className="mb-2">
    <strong>Dispute Type:</strong> {item.disputeType}
  </h6>
  <h6 className="mb-2">
    <strong>Filed Date:</strong> {item.filedDate}
  </h6>
  <h6 className="mb-2">
    <strong>Last Updated:</strong> {item.lastUpdated}
  </h6>
  <h6 className="mb-2">
    <strong>Status:</strong>{" "}
    <small >{item.status}</small>
  </h6>
  <h6 className="mb-2">
    <strong>Priority:</strong>{" "}
    <span
      className={`btn btn-sm px-2 text-capitalize ${
        item.priority?.toLowerCase() === "high"
          ? "btn-danger"
          : item.priority?.toLowerCase() === "medium"
          ? "btn-warning"
          : "btn-success"
      }`}
    >
      {item.priority}
    </span>
  </h6>
</Col>


                  <Col xs={2}>
                    <div>
                      <Dropdown
                        isOpen={item.dropdownOpen || false}
                        toggle={(e) => {
                          e.stopPropagation();
                          setDataList((prev) =>
                            prev.map((dbItem) =>
                              dbItem.id === item.id
                                ? {
                                    ...dbItem,
                                    dropdownOpen: !dbItem.dropdownOpen,
                                  }
                                : { ...dbItem, dropdownOpen: false }
                            )
                          );
                        }}
                        direction="down"
                      >
                        <DropdownToggle
                          color="primary"
                          outline
                          className="btn-sm shadow-sm rounded-circle"
                        >
                          <i className="ri-more-2-fill"></i>
                        </DropdownToggle>
                        <DropdownMenu end>
                          <DropdownItem
                            onClick={() => {
                              setAddModal(true);
                            }}
                          >
                            <i className="ri-edit-line text-warning me-2"></i>{" "}
                            Edit
                          </DropdownItem>
                          <DropdownItem>
                            <i className="ri-delete-bin-5-line text-danger me-2"></i>{" "}
                            Delete
                          </DropdownItem>
                        </DropdownMenu>
                      </Dropdown>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          ))}
        </>
      )}
    </div>
  );
}

export default PendingListPage
